

export enum KalturaLanguage {
    aa = 'Afar',
	aal = 'Afade',
	ab = 'Abkhazian',
	abe = 'Abnaki Western',
	abq = 'Abaza',
	abu = 'Abure',
	ace = 'Achinese',
	acf = 'Saint Lucian Creole French',
	acn = 'Achang',
	act = 'Achterhooks',
	acv = 'Achumawi',
	adj = 'Adioukrou',
	adt = 'Adynyamathanha',
	ady = 'Adyghe; Adygei',
	af = 'Afrikaans',
	agq = 'Aghem',
	agr = 'Aguaruna',
	agu = 'Aguacateco',
	agx = 'Aghul',
	aii = 'Assyrian Neo-Aramaic',
	ain = 'Ainu (Japan)',
	akk = 'Akkadian',
	akl = 'Aklanon',
	aku = 'Akum',
	akz = 'Alabama',
	alc = 'Qawasqar',
	ale = 'Aleut',
	alg = 'Algonquian languages',
	aln = 'Albanian (Gheg)',
	alq = 'Algonquin',
	als = 'Albanian (Tosk)',
	alt = 'Altai (Southern)',
	am = 'Amharic',
	ame = 'Yanesha',
	amw = 'Western Neo-Aramaic',
	ang = 'Old English',
	apj = 'Apache (Jicarilla)',
	apw = 'Apache (Western)',
	ar = 'Arabic',
	arb = 'Arabic (standard)',
	arc = 'Aramaic',
	ari = 'Arikara',
	arn = 'Araucanian',
	arp = 'Arapaho',
	asb = 'Assiniboine',
	ast = 'Asturian',
	as = 'Assamese',
	ath = 'Athapascan languages',
	atj = 'Atikamekw',
	auc = 'Waorani',
	avk = 'Kotava',
	awa = 'Awadhi',
	ay = 'Aymara',
	az = 'Azerbaijani',
	ba = 'Bashkir',
	bal = 'Baluchi',
	ban = 'Balinese',
	bar = 'Bavarian',
	bas = 'Basa (Cameroon)',
	bcc = 'Balochi Southern',
	bcr = 'Babine',
	bdj = 'Bai',
	be = 'Byelorussian (Belarusian)',
	bea = 'Beaver',
	bej = 'Beja',
	bem = 'Bemba (Zambia)',
	bew = 'Betawi',
	bfq = 'Badaga',
	bft = 'Balti',
	bg = 'Bulgarian',
	bh = 'Bihari',
	bhb = 'Bhili',
	bho = 'Bhojpuri',
	bi = 'Bislama',
	bik = 'Bikol',
	bin = 'Bini',
	bla = 'Siksika',
	bn = 'Bengali (Bangla)',
	bo = 'Tibetan',
	bpy = 'Bishnupriya Manipuri',
	br = 'Breton',
	bua = 'Buriat',
	bug = 'Buginese',
	bT = 'Arabic Tunisian Spoken',
	ca = 'Catalan',
	caa = 'Chor',
	cad = 'Caddo',
	caf = 'Carrier Southern',
	cay = 'Cayuga',
	cdo = 'Min Dong Chinese',
	ceb = 'Cebuano',
	chc = 'Catawba',
	chg = 'Chagatai',
	chm = 'Mari (Russia)',
	chn = 'Chinook jargon',
	cho = 'Choctaw',
	chp = 'Chipewyan',
	chr = 'Cherokee',
	chy = 'Cheyenne',
	cic = 'Chickasaw',
	cim = 'Cimbrian',
	ciw = 'Chippewa',
	cjs = 'Shor',
	cjy = 'Jinyu Chinese',
	ckt = 'Chukot',
	clc = 'Chilcotin',
	cld = 'Chaldean Neo-Aramaic',
	clm = 'Clallam Klallam',
	cmn = 'Mandarin Chinese',
	co = 'Corsican',
	coc = 'Cocopa',
	coj = 'Cochimi',
	com = 'Comanche',
	coo = 'Comox',
	cop = 'Coptic',
	cr = 'Cree',
	crg = 'Michif',
	crh = 'Crimean Tatar',
	crx = 'Carrier',
	cs = 'Czech',
	csb = 'Kashubian',
	cup = 'Cupeo',
	cy = 'Welsh',
	czh = 'Huizhou Chinese',
	da = 'Danish',
	dak = 'Dakota',
	dar = 'Dargwa',
	ddo = 'Tsez',
	de = 'German',
	del = 'Delaware',
	dgr = 'Dogrib',
	dhv = 'Dehu',
	dih = 'Kumiai',
	din = 'Dinka',
	dje = 'Zarma',
	dlg = 'Dolgan',
	dng = 'Dungan',
	doh = 'Dong',
	doi = 'Dogri (generic)',
	dsb = 'Sorbian Lower',
	dua = 'Duala',
	dyu = 'Dyula',
	dz = 'Bhutani',
	eee = 'E',
	egl = 'Emilian',
	el = 'Greek',
	en = 'English',
	enm = 'English Middle (1100-1500)',
	enGb = 'English (British)',
	enUs = 'English (American)',
	eo = 'Esperanto',
	es = 'Spanish',
	esXl = 'Spanish (Latin America)',
	et = 'Estonian',
	eu = 'Basque',
	eve = 'Even',
	evn = 'Evenki',
	fa = 'Farsi',
	fan = 'Fang (Equatorial Guinea)',
	fax = 'Fala',
	fi = 'Finnish',
	fil = 'Filipino',
	fit = 'Finnish (Tornedalen)',
	fj = 'Fiji',
	fo = 'Faeroese',
	fon = 'Fon',
	fr = 'French',
	frk = 'Frankish',
	frp = 'Franco-Prove',
	frr = 'Frisian Northern',
	frCa = 'French (Canada)',
	fuc = 'Pulaar',
	fur = 'Friulian',
	fvr = 'Fur',
	fy = 'Frisian',
	ga = 'Irish',
	gaa = 'Ga',
	gag = 'Gagauz',
	gan = 'Gan',
	gbz = 'Dari Zoroastrian',
	gd = 'Gaelic (Scottish)',
	gdm = 'Laal',
	geh = 'German Hutterite',
	gez = 'Geez',
	gil = 'Gilbertese',
	git = 'Gitxsan',
	gl = 'Galician',
	gld = 'Nanai',
	gn = 'Guarani',
	gom = 'Konkani Goan',
	grc = 'Greek Ancient (to 1453)',
	gsw = 'Swiss German Alemannic Alsatian',
	gu = 'Gujarati',
	gv = 'Gaelic (Manx)',
	gwi = 'Gwichin',
	ha = 'Hausa',
	haa = 'Han',
	hai = 'Haida',
	hak = 'Hakka',
	has = 'Haisla',
	haw = 'Hawaiian',
	he = 'Hebrew',
	hei = 'Heiltsuk',
	hi = 'Hindi',
	hid = 'Hidatsa',
	hil = 'Hiligaynon',
	hkk = 'Hokkien',
	hmn = 'Hmong',
	hni = 'Hani',
	hnn = 'Hainanese',
	hop = 'Hopi',
	hr = 'Croatian',
	hsb = 'Sorbian Upper',
	hu = 'Hungarian',
	hur = 'Halkomelem',
	hy = 'Armenian',
	ia = 'Interlingua',
	id = 'Indonesian',
	ie = 'Interlingue',
	ik = 'Inupiak',
	ikt = 'Inuinnaqtun',
	ilo = 'Iloko',
	in = 'Indonesian',
	inh = 'Ingush',
	iro = 'Iroquoian languages',
	is = 'Icelandic',
	it = 'Italian',
	itl = 'Itelmen',
	iu = 'Inuktitut',
	iw = 'Hebrew',
	izh = 'Ingrian',
	ja = 'Japanese',
	jbo = 'Lojban',
	jct = 'Judeo-Crimean Tatar',
	jge = 'Judeo-Georgian',
	ji = 'Yiddish',
	jut = 'Jutish',
	jv = 'Javanese',
	ka = 'Georgian',
	kaa = 'Karakalpak',
	kab = 'Kabyle',
	kaj = 'Jju',
	kap = 'Bezhta',
	kaw = 'Kawi',
	kbd = 'Kabardian',
	kca = 'Khanty',
	kdr = 'Karaim',
	kea = 'Kabuverdianu',
	kfa = 'Kodava',
	kfr = 'Kachchi',
	kha = 'Khasi',
	kic = 'Kickapoo',
	kim = 'Karagas',
	kio = 'Kiowa',
	kjh = 'Khakas',
	kjv = 'Kaikavian literary language (Kajkavian)',
	kk = 'Kazakh',
	kkz = 'Kaska',
	kl = 'Greenlandic',
	klj = 'Khalaj Turkic',
	km = 'Cambodian',
	kn = 'Kannada',
	knn = 'Konkani (specific)',
	ko = 'Korean',
	koi = 'Komi-Permyak',
	kok = 'Konkani (generic)',
	kos = 'Kosraean',
	kpe = 'Kpelle',
	kpo = 'Ikposo',
	kpy = 'Koryak',
	krc = 'Karachay-Balkar',
	krl = 'Karelian',
	ks = 'Kashmiri',
	ksh = 'Colognian',
	ksk = 'Kansa',
	ku = 'Kurdish',
	kum = 'Kumyk',
	kut = 'Kutenai',
	kwk = 'Kwakiutl',
	kxm = 'Khmer Northern',
	ky = 'Kirghiz',
	la = 'Latin',
	lad = 'Ladino',
	lah = 'Lahnda',
	lb = 'Luxembourgish (Letzeburgesch)',
	lbe = 'Lak',
	lez = 'Lezghian',
	lhu = 'Lahu',
	li = 'Limburgish ( Limburger)',
	lif = 'Limbu',
	lij = 'Ligurian',
	lil = 'Lillooet',
	lki = 'Laki',
	lkt = 'Lakota',
	lld = 'Ladin',
	lmo = 'Lombard',
	ln = 'Lingala',
	lo = 'Laothian',
	lom = 'Loma (Liberia)',
	loz = 'Lozi',
	lt = 'Lithuanian',
	lua = 'Luba-Lulua',
	lud = 'Ludian',
	lun = 'Lunda',
	luo = 'Luo (Kenya and Tanzania)',
	luq = 'Lucumi',
	lut = 'Lushootseed',
	lv = 'Latvian (Lettish)',
	lzz = 'Laz',
	mad = 'Madurese',
	mag = 'Magahi',
	mai = 'Maithili',
	mas = 'Masai',
	mdf = 'Moksha',
	men = 'Mende (Sierra Leone)',
	mez = 'Menominee',
	mfe = 'Morisyen',
	mfy = 'Mayo',
	mg = 'Malagasy',
	mhq = 'Mandan',
	mi = 'Maori',
	mic = 'Micmac',
	mid = 'Mandaic',
	min = 'Minangkabau',
	mk = 'Macedonian',
	ml = 'Malayalam',
	mn = 'Mongolian',
	mnc = 'Manchu',
	mni = 'Meitei',
	mnp = 'Min Bei Chinese',
	mns = 'Mansi',
	mnw = 'Mon',
	mo = 'Moldavian',
	moe = 'Montagnais',
	moh = 'Mohawk',
	mos = 'Mossi',
	mr = 'Marathi',
	mrw = 'Maranao',
	ms = 'Malay',
	mt = 'Maltese',
	mtq = 'Muong',
	mu = 'Multilingual',
	mus = 'Creek',
	mwl = 'Mirandese',
	mwr = 'Marwari',
	mxi = 'Mozarabic',
	my = 'Burmese',
	myp = 'Pirah',
	myv = 'Erzya',
	mzb = 'Tumzabt',
	na = 'Nauru',
	nap = 'Neapolitan',
	naq = 'Nama (Namibia)',
	ncg = 'Nisgaa',
	nds = 'Low German Low Saxon',
	ne = 'Nepali',
	new = 'Newari Nepal Bhasa',
	nio = 'Nganasan',
	niu = 'Niuean',
	niv = 'Gilyak Nivkh',
	nl = 'Dutch',
	no = 'Norwegian',
	nod = 'Thai (Northern)',
	nog = 'Nogai',
	non = 'Norse Old',
	nov = 'Novial',
	nsk = 'Naskapi',
	nso = 'Northern Sotho Pedi Sepedi',
	nym = 'Nyamwezi',
	nyo = 'Nyoro',
	nys = 'Nyungah',
	oc = 'Occitan',
	oj = 'Ojibwe, Ojibwa',
	ojb = 'Ojibwa Northwestern',
	ojc = 'Ojibwa Central',
	ojg = 'Ojibwa Eastern',
	ojs = 'Ojibwa Severn',
	ojw = 'Ojibwa Western',
	oka = 'Okanagan',
	om = 'Oromo (Afan, Galla)',
	one = 'Oneida',
	ono = 'Onondaga',
	ood = 'Tohono Oodham',
	or = 'Oriya',
	ota = 'Turkish Ottoman',
	otw = 'Ottawa',
	pa = 'Punjabi',
	pag = 'Pangasinan',
	pam = 'Pampanga',
	pap = 'Papiamento',
	pau = 'Palauan',
	pcd = 'Picard',
	pdc = 'German Pennsylvania',
	pdt = 'Plautdietsch',
	pes = 'Western Farsi',
	pfl = 'Pfaelzisch',
	pih = 'Pitcairn-Norfolk',
	pl = 'Polish',
	pms = 'Piedmontese',
	pnt = 'Pontic',
	pot = 'Potawatomi',
	ppi = 'Paipai',
	pqm = 'Malecite-Passamaquoddy',
	prd = 'Dari (Persian)',
	prg = 'Prussian',
	prp = 'Persian',
	prs = 'Persian (Dari)',
	ps = 'Pashto (Pushto)',
	pt = 'Portuguese',
	ptBr = 'Portuguese (Brazil)',
	qtz = 'Reserved for local use.',
	qu = 'Quechua',
	quc = 'Quich Central',
	qxq = 'Qashqai',
	rap = 'Rapanui',
	rar = 'Rarotongan',
	rcf = 'Runion Creole French',
	rgn = 'Romagnol',
	rm = 'Rhaeto-Romance',
	rme = 'Angloromani',
	rmf = 'Romani Kalo Finnish',
	rmo = 'Romani Sinte',
	rn = 'Kirundi (Rundi)',
	ro = 'Romanian',
	rom = 'Romany',
	ru = 'Russian',
	rue = 'Rusyn',
	ruo = 'Romanian Istro',
	rup = 'Aromanian',
	ruq = 'Romanian Megleno',
	rw = 'Kinyarwanda (Ruanda)',
	ryu = 'Okinawan Central',
	sa = 'Sanskrit',
	sah = 'Sakha',
	sal = 'Salishan languages',
	sam = 'Aramaic Samaritan',
	sat = 'Santali',
	scn = 'Sicilian',
	sco = 'Scots',
	scs = 'Slavey North',
	sd = 'Sindhi',
	sdc = 'Sardinian Sassarese',
	sec = 'Sechelt',
	see = 'Seneca',
	sei = 'Seri',
	sek = 'Sekani',
	sel = 'Selkup',
	sg = 'Sangro',
	sh = 'Serbo-Croatian',
	shh = 'Shoshoni',
	shi = 'Tachelhit',
	shs = 'Shuswap',
	shy = 'Tachawit',
	si = 'Sinhalese',
	sid = 'Sidamo',
	sjd = 'Sami Kildin',
	sjw = 'Shawnee',
	sk = 'Slovak',
	sl = 'Slovenian',
	slr = 'Salar',
	sm = 'Samoan',
	sma = 'Southern Sami',
	smi = 'Sami languages',
	smj = 'Lule Sami',
	smn = 'Inari Sami',
	sms = 'Skolt Sami',
	sn = 'Shona',
	snk = 'Soninke',
	so = 'Somali',
	sq = 'Albanian',
	sr = 'Serbian',
	srm = 'Saramaccan',
	srn = 'Sranan',
	ss = 'Siswati',
	st = 'Sesotho',
	sto = 'Stoney',
	stq = 'Saterland Frisian',
	str = 'Salish Straits',
	su = 'Sundanese',
	sux = 'Sumerian',
	sv = 'Swedish',
	sva = 'Svan',
	sw = 'Swahili (Kiswahili)',
	swb = 'Comorian',
	swg = 'Swabian',
	swl = 'Swedish Sign Language',
	sxu = 'Saxon Upper',
	syr = 'Syriac',
	szl = 'Silesian',
	ta = 'Tamil',
	tab = 'Tabassaran',
	taq = 'Tamasheq',
	tar = 'Tarahumara Central',
	tbw = 'Tagbanwa',
	tce = 'Southern Tutchone',
	tcx = 'Toda',
	tcy = 'Tulu',
	tdd = 'Tai Na',
	te = 'Telugu',
	teo = 'Teo Chew',
	tet = 'Tetum',
	tg = 'Tajik',
	tgx = 'Tagish',
	th = 'Thai',
	thp = 'Thompson',
	tht = 'Tahltan',
	ti = 'Tigrinya',
	tig = 'Tigre',
	tk = 'Turkmen',
	tl = 'Tagalog',
	tlh = 'Klingon tlhIngan-Hol',
	tli = 'Tlingit',
	tly = 'Talysh',
	tn = 'Setswana',
	to = 'Tonga',
	tog = 'Tonga (Nyasa)',
	tpi = 'Tok Pisin',
	tpn = 'Tupinamb',
	tr = 'Turkish',
	trv = 'Seediq',
	ts = 'Tsonga',
	tsi = 'Tsimshian',
	tt = 'Tatar',
	ttq = 'Tamajaq Tawallammat',
	tts = 'Thai Northeastern',
	ttt = 'Tat Muslim',
	tum = 'Tumbuka',
	tus = 'Tuscarora',
	tuv = 'Turkana',
	tvl = 'Tuvalu',
	tw = 'Twi',
	tyv = 'Tuvinian',
	tzm = 'Tamazight Central Atlas',
	uby = 'Ubykh',
	udi = 'Udi',
	udm = 'Udmurt',
	ug = 'Uighur',
	uk = 'Ukrainian',
	un = 'Undefined',
	ur = 'Urdu',
	uum = 'Urum',
	uz = 'Uzbek',
	vec = 'Venetian',
	vep = 'Veps',
	vi = 'Vietnamese',
	vo = 'Volapuk',
	vor = 'Voro',
	vot = 'Votic',
	vro = 'Vro',
	war = 'Waray (Philippines)',
	wiy = 'Wiyot',
	wo = 'Wolof',
	wuu = 'Wu Chinese',
	wym = 'Wymysorys',
	xal = 'Kalmyk Oirat',
	xh = 'Xhosa',
	xmf = 'Mingrelian',
	xsl = 'Slavey South',
	xsv = 'Sudovian',
	yi = 'Yiddish',
	yo = 'Yoruba',
	yue = 'Cantonese',
	zai = 'Zapotec Isthmus',
	zh = 'Chinese',
	zhTw = 'Taiwanese Mandarin',
	zu = 'Zulu',
	zxx = 'No linguistic content'
}